<template>
  <v-container>
    <v-data-table :headers="dTable.headers" :items="servicios" :loading="dTable.loading" :search="dTable.search" class="elevation-1">
        <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning" outline>No hay registros para mostrar.</v-alert></template>
        <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning" outline>No se encontro ningun registro con su busqueda "{{ dTable.search }}".</v-alert></template>
        <template slot="items" slot-scope="props">
          <td class="justify-center layout px-0">
            <v-menu offset-y>
              <v-btn icon slot="activator"><v-icon>more_vert</v-icon></v-btn>
            </v-menu>
          </td>
          <td><pre>{{props}}</pre></td>
        </template>
      </v-data-table>
      <pre>{{servicios}}</pre>
  </v-container>
</template>

<script>
  import gql from 'graphql-tag'
  export default {
    name: 'Servicio',
    mounted(){
        this.getCategories();
    },
    data: () => ({
      servicios: [],
      user: null,
      dTable: {
        headers: [
          {value: 'actions', text: '...', sortable: false},
          {value: 'IdServicio', text: 'IdServicio', align: 'center'},
          {value: 'Iniciales', text: 'Iniciales', align: 'center'},
          {value: 'Descripcion', text: 'Descripcion', align: 'center'}
        ],
        loading: true,
        search: null,
      }
    }),
    methods: {
        async getCategories() {
            this.dTable.loading = true;
            const response = await this.$apollo.query({
                query: gql`{
                    priservicioByIdCentroProdByActivo(IdCentroProd: 1, Activo:1){
                        IdServicio
                        Iniciales
                        Descripcion
                    }
                }`
            })
            this.servicios = response.data.priservicioByIdCentroProdByActivo;
            this.dTable.loading = false
        }
    }
    /*apollo: {
      servicios: gql`{
        servicios{
          Iniciales
        }
      }`,
    }*/
  }
</script>
